import { FC, useState } from "react";

import { Button, Typography } from "@mui/material";

import { IDeviceTableRow } from "../../hooks/useDeviceTableRows";
import LiveViewDialog from "../../../data-hub/components/liveview/components/dialog/LiveViewDialog";

interface PtControllerDialogProps {
  device: IDeviceTableRow;
  changeViewMode: (closeLiveView: boolean) => void;
  showPtButton?: boolean;
}

const PtControllerDialog: FC<PtControllerDialogProps> = ({
  device,
  changeViewMode,
  showPtButton,
}): JSX.Element => {
  const { node } = device;

  const { id: nodeId } = node;

  const [open, setOpen] = useState(false);

  const handleOpenPtControlsOnClick = (): void => {
    setOpen(true);
  };

  const liveViewHandler = (value: boolean): void => {
    setOpen(value);

    changeViewMode(true);
  };

  return (
    <>
      {showPtButton && (
        <Button
          sx={{
            "&": {
              color: "text.primary",
              borderColor: "text.primary",
              backgroundColor: "otherBackgroundLight.main",
              textTransform: "none",
            },
            "&:hover": {
              color: "primary.main",
              borderColor: "primary.main",
              backgroundColor: "otherBackgroundLight.main",
              textTransform: "none",
            },
          }}
          variant="outlined"
          size="small"
          onClick={handleOpenPtControlsOnClick}
        >
          <Typography variant="buttonMedium" component="span">
            Open PT controller
          </Typography>
        </Button>
      )}

      {open && (
        <LiveViewDialog
          setOpen={liveViewHandler}
          deviceId={device.rowId}
          deviceName={device.name}
          locationName={device.location.name}
          nodeId={nodeId}
          hasPanTilt={device.deviceData.hasPanTilt}
          hasZoom={Boolean(device.deviceData.hasZoom)}
          deviceData={{ __typename: "DeviceData", ...device.deviceData }}
          currentPosition={device.currentPosition}
          currentDevice={device.rowId}
        />
      )}
    </>
  );
};

export default PtControllerDialog;
